
import { MATTRESS_FINDER } from '~/api/apolloListingQueries';
import routeMixin from '~/mixins/routeMixin';

export default {
  name: 'ListingMattressFinder',
  mixins: [routeMixin],
  data: () => ({
    isInactive: true,
    mattressFinder: null,
    currentStep: 1,
    stepsLength: null,
    initialStepsInfo: [],
    finalStepsInfo: [],
    isWait: false,
    stepsProgress: [],
  }),
  props: {
    loading: {
      type: Object,
    },
    isVirtual: {
      type: Boolean,
      default: false,
    },
  },
  async fetch() {
    const f1 = async () => {
      const { listing } = await this.$graphql.default.request(MATTRESS_FINDER) || {};
      this.mattressFinder = listing.mattressFinder;
      this.stepsLength = this.mattressFinder.length;
      this.stepsProgress = this.mattressFinder.map((item, index) => ({
        name: item.name,
        step: index + 1,
      }));
    };
    try {
      await
      f1();
    } catch (e) {
      console.error(e);
    }
  },
  mounted() {
    let breakpoint = this.$vuetify.breakpoint.mdAndDown;
    if (this.$store.state.listing.isTryMattressFinder && this.$vuetify.breakpoint.mdAndDown) {
      breakpoint = false;
      this.$store.commit('listing/setTryMattressFinder', false);
    }
    this.isInactive = Boolean(this.isInactiveCount) || Boolean(this.$route.params?.type) || breakpoint;
  },
  watch: {
    fasets(newValue, oldValue) {
      if (this.isVirtual) {
        this.isInactive = true;
        return;
      }
      if (Object.keys(newValue).length === 0) {
        this.isInactive = false;
        this.finalStepsInfo = [];
        this.currentStep = 1;
      } else {
        if (this.finalStepsInfo.length) {
          if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
            return;
          }
          this.finalStepsInfo = [];
          this.currentStep = 1;
        } else if (this.isAllSteps) {
          this.finalStepsInfo = [...this.initialStepsInfo];
          this.initialStepsInfo = [];
          return;
        } else if (this.initialStepsInfo.length) {
          this.initialStepsInfo = [];
          this.currentStep = 1;
        }
        this.isInactive = true;
      }
    },
    '$vuetify.breakpoint.mdAndDown': function mdAndDownWatcher(newValue) {
      if (this.currentStep === 1) {
        this.isInactive = newValue;
      }
    },
    isAllSteps(newValue) {
      if (newValue) this.isWait = true;
    },
    isLoadingCount(newValue) {
      if (!newValue && this.isWait) this.isWait = false;
    },
  },
  computed: {
    isAllSteps() {
      return this.initialStepsInfo.length === this.stepsLength || Boolean(this.finalStepsInfo.length);
    },
    isloadingMattressFinder() {
      return !(this.mattressFinder && this.mattressFinder.length);
    },
    isInactiveCount() {
      return Object.keys(this.fasets || {})
        .reduce((count, key) => count + (this.fasets[key]?.split('$,$') || []).length, 0);
    },
    isLoadingCount() {
      return Number(this.loading?.filters) + Number(this.loading?.price) + Number(this.loading?.products);
    },
    fasets() {
      const query = { ...(this.$route.query || {}) };
      delete query['per-page'];
      delete query['sort-by'];
      delete query.page;
      delete query.q;
      delete query.s;
      // eslint-disable-next-line no-underscore-dangle
      delete query._mattress_position;
      return query;
    },
  },
  methods: {
    selectStep(attributeCode, value) {
      const currenStep = {};
      currenStep.attributeCode = attributeCode;
      currenStep.value = [value];
      if (this.initialStepsInfo.length && this.initialStepsInfo.find((item) => item.attributeCode === attributeCode)) {
        const newArray = this.initialStepsInfo
          .map((item) => (item.attributeCode === attributeCode ? currenStep : item));
        this.initialStepsInfo = [...newArray];
      } else {
        this.initialStepsInfo = [...this.initialStepsInfo, currenStep];
      }
      this.currentStep += 1;
      this.currentStep = this.currentStep > this.stepsLength ? this.stepsLength : this.currentStep;
      if (this.initialStepsInfo.length === this.stepsLength) {
        const resultObject = this.initialStepsInfo.reduce((acc, item) => {
          const key = item.attributeCode;
          acc[key] = item.value.map((attrValue) => ({ attrValue }));
          return acc;
        }, {});
        this.changeRouteFacets({
          selected: resultObject,
          customPrice: null,
        });
      }
    },
    backStep(step) {
      if (!step) {
        this.currentStep -= 1;
      } else if (this.initialStepsInfo.length >= step) {
        this.currentStep = step;
      }
    },
    resetStep() {
      this.finalStepsInfo = [];
      this.currentStep = 1;
      this.resetFilters();
    },
    openForm() {
      this.isInactive = false;
      this.$store.commit('listing/setTryMattressFinder', true);
      this.resetFilters();
    },
  },
};
